import React from 'react';
import { PERCENT } from '../../lib/device/catalog';
import { ACCENT_SPECS } from '../../lib/rcu/catalog/accent';
import type { CapacityBand } from '../../lib/rcu/query/capacity';

export interface CapacityMeterProps {
  bands: readonly CapacityBand[];
  totalOutputs: number;
  usedOutputs: number;
}

const percentOf = (used: number, total: number): number =>
  total === 0 ? 0 : Math.round((used / total) * PERCENT.MAX);

const CapacityRow: React.FC<{ band: CapacityBand }> = ({ band }) => {
  const spec = ACCENT_SPECS[band.accent];
  const free = band.total - band.used;

  return (
    <div>
      <div className="mb-1.5 flex items-baseline justify-between text-sm">
        <span className="flex items-center gap-2 text-[#333333]">
          <span className={`h-2.5 w-2.5 rounded-full ${spec.dot}`} />
          {band.label}
        </span>
        <span className="text-[#666666]">
          <span className="font-medium text-[#333333]">{band.used}</span> / {band.total} used
          <span className="ml-2 text-xs">{free} free</span>
        </span>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-[#F5F5F5]">
        <div
          className={`h-full rounded-full ${spec.dot}`}
          style={{ width: `${percentOf(band.used, band.total)}%` }}
        />
      </div>
    </div>
  );
};

/** How much of the hardware is wired, per family. */
export const CapacityMeter: React.FC<CapacityMeterProps> = ({
  bands,
  totalOutputs,
  usedOutputs,
}) => (
  <div className="space-y-4">
    <div className="flex items-baseline justify-between">
      <span className="text-sm text-[#666666]">Total outputs</span>
      <span className="font-display text-2xl text-[#333333]">
        {usedOutputs}
        <span className="text-base text-[#666666]"> / {totalOutputs}</span>
      </span>
    </div>
    {bands.map((band) => (
      <CapacityRow key={band.id} band={band} />
    ))}
  </div>
);

export default CapacityMeter;
